export default "__VITE_ASSET__BrB9xzs6__"